// extracted by mini-css-extract-plugin
export default {"sec--card":"SECCard_sec--card__4wJQ4","sec--card--element":"SECCard_sec--card--element__kEuBY"};